<template>
  <div id="authenticated">
     {{ $t('authenticated.lblMessage') }}
    <div id="authenticatedform" style="display:none">
      <form
        ref="form"
        id="authenticatedform"
        v-bind:action="redirectUrl"
        method="post"
      >
      <input
          id="idToken"
          name="idToken"
          v-model="$root.$data.idToken" />

        <span v-for="(value,name) in qq" v-bind:key="name">
          <input
            v-bind:id="name"
            type="text"
            v-bind:value="value"
            v-bind:name="name" />
        </span>

        <div class="btn-container">
          <button id="sbmbtn" refs="submitbtn" type="submit" class="btn btn-primary">submit</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'authenticated',
  data () {
    return {
      redirectUrl: process.env.VUE_APP_COMMUNITY_SITE_URL,
      qq: {} ,
    }
  },
  created(){
    this.paramValidate();
    const idToken = this.$root.$data.idToken;
    if(!idToken){
      this.$router.push({ path: 'onetime-input' , query: this.$route.query })
    }
    this.$i18n.locale = ['ja', 'en'].includes(this.$route.query.lang) ? this.$route.query.lang : 'ja'
  },
  mounted(){
    this.nextAction();
  },  
  methods: {
    paramValidate() {
      const qp = this.$route.query;
      const excludeQueryParam = [];
      for (const [key, value] of Object.entries(qp)) {
        if(!excludeQueryParam.includes(key.toUpperCase())){
          this.qq[key] = value;
        }
      }
    },
    nextAction(){
      window.localStorage.clear();
      this.$refs.form.submit();
    }
  }
}
</script>
